import { Popup } from '@calendly/ui/components/popup'
import styled from 'astroturf/react'
import { Loader } from '@calendly/ui/components/loader'
import { useEffect, useState } from 'react'
import { parseQuery, httpRequest } from '@calendly/http-tools'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { useI18n } from '../../../locales'
import { setIsBookingAfterStripeRedirect, setSavedFormDataAfterStripeRedirect } from '../../../actions/scheduling'
import {
  setPaymentData,
  setStripePaymentElementReadyForCapture,
} from '../../../actions/payment'
import _TextWrapper from "stripe_redirect_handler-TextWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/payment/stripe_redirect_handler.js?styleId=TextWrapper";
import _PopupContent from "stripe_redirect_handler-PopupContent.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/payment/stripe_redirect_handler.js?styleId=PopupContent";


const TextWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "TextWrapper",
  styles: _TextWrapper
})

const PopupContent = /*#__PURE__*/styled('div', null, {
  displayName: "PopupContent",
  styles: _PopupContent
})

export const StripeRedirectHandler = () => {
  const { i18n } = useI18n()
  const query = parseQuery(window.location.search)
  const paymentIntentId = query.payment_intent
  const paymentIntentClientSecret = query.payment_intent_client_secret
  const dispatch = useDispatch()
  const [rehydrationFailed, setRehydrationFailed] = useState(false)
  const schedulingError = useSelector((state) => state.scheduling.error)
  const location = useLocation()

  useEffect(() => {
    dispatch(setStripePaymentElementReadyForCapture())
    dispatch(setPaymentData({
      payment_intent_client_secret: paymentIntentClientSecret,
      payment_element_flow: true
    }))
  }, [dispatch, paymentIntentClientSecret])

  useEffect(() => {
    let active = true

    const hydrateFromBackend = async () => {
      if (!paymentIntentId) {
        setRehydrationFailed(true)
        return
      }

      const [ok, response] = await httpRequest({
        url: `/api/booking/stripe_redirect_sessions/${paymentIntentId}`,
        method: 'GET'
      })

      if (!active) return

      const formData = response?.resource?.form_data
      if (ok && formData) {
        dispatch(setSavedFormDataAfterStripeRedirect(formData))
        dispatch(setIsBookingAfterStripeRedirect(true))
      } else {
        setRehydrationFailed(true)
      }
    }

    hydrateFromBackend()

    return () => {
      active = false
    }
  }, [dispatch, paymentIntentId])

  useEffect(() => {
    if (schedulingError) {
      // If there was a scheduling error, it might be anything from slot filled to payment error
      // Regardless, cancel this payment altogether, hard refresh page,
      // and force user to go through payment flow again
      const queryParams = new URLSearchParams(location.search)
      if (queryParams.has('payment_intent')) queryParams.delete('payment_intent')
      if (queryParams.has('payment_intent_client_secret')) queryParams.delete('payment_intent_client_secret')

      window.location.href = `${location.pathname}?${queryParams}`
    }
  }, [location, schedulingError])

  useEffect(() => {
    if (!rehydrationFailed) return

    const queryParams = new URLSearchParams(location.search)
    if (queryParams.has('payment_intent')) queryParams.delete('payment_intent')
    if (queryParams.has('payment_intent_client_secret')) queryParams.delete('payment_intent_client_secret')

    window.location.href = `${location.pathname}?${queryParams}`
  }, [location, rehydrationFailed])

  return (
    <Popup onClose={() => null}>
      <PopupContent>
        <Loader />

        <TextWrapper>
          {i18n.t('booking.templates.payment.wrapping_up')}
        </TextWrapper>
      </PopupContent>
    </Popup>
  )
}
